"use strict";

export function initInScope($scope) {
    $scope.find('.js-scroll-top').on('click', function() {
        $('body,html').animate({
            scrollTop : 0
        }, 800);
    });
}